import { ThemeEvents } from '@theme/events';

/**
 * Leje/leasing-modul (Grenke).
 *
 * Ved variantskift erstattes hele elementet med Horizons friske variant-html
 * (event.detail.data.html) — samme mønster som media-gallery.js. Det betyder
 * al pris/restværdi-beregning forbliver ren Liquid, ingen dobbelt prislogik i
 * JS. Mangler den nye variant en lejepris, findes elementet slet ikke i den
 * friske html (blokken er tag-if'et væk i Liquid), og modulet skjules.
 *
 * Foldes ud/ind efter kundetype (data-customer, sat af assets/customer-type.js
 * før first paint) — samme mønster som moms-visning i ex-vat.js.
 */
class LejeGrenke extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
    window.addEventListener('lw:customer-change', this.#onCustomerChange, { signal });

    const details = this.querySelector('[ref="details"]');
    if (details && document.documentElement.dataset.customer === 'erhverv') details.open = true;

    this.querySelector('[ref="cta"]')?.addEventListener('click', this.#onCtaClick, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #onCustomerChange = (event) => {
    const details = this.querySelector('[ref="details"]');
    if (details) details.open = event.detail?.type === 'erhverv';
  };

  /** GA4/GTM: sporer klik på "Anmod om lejetilbud". Ses straks i GTM Preview;
   * kræver en GA4-tag+trigger i selve GTM-containeren for at nå GA4. */
  #onCtaClick = (event) => {
    const url = new URL(event.currentTarget.href, window.location.origin);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'leje_cta_klik',
      produkt: url.searchParams.get('produkt') || '',
      kilde: 'produktside',
    });
  };

  #onVariantUpdate = (event) => {
    const source = event.detail?.data?.html;
    if (!source) return;

    const fresh = source.querySelector('leje-grenke');
    if (!fresh) {
      // Den nye variant har ingen lejepris sat — blokken renderes slet ikke af Liquid.
      this.hidden = true;
      return;
    }
    this.replaceWith(fresh);
  };
}

if (!customElements.get('leje-grenke')) {
  customElements.define('leje-grenke', LejeGrenke);
}
